import React, { useState } from "react";
import SOPInstanceOpenLayerSource from "./SOPInstanceOpenLayerSource";
import "ol/ol.css";
import "./ViewedSopInstanceMap.css";
 
const ViewedSopInstanceMap = () => {
  const center = { lat: 25.747554, lng: 85.562257 };
  const zoom = 8;
 
  const [map, setMap] = useState(null);
  const [source, setSource] = useState(null);
 
  const setMapInstance = (mapInstance, sourceInstance) => {
    setMap(mapInstance);
    setSource(sourceInstance);
  };
 
  
 
  return (
    <>
      {/* Map Container */}
      <div style={{ width: "100%", height: "400px", marginTop: "20px" }}>
        <SOPInstanceOpenLayerSource
          zoom={zoom}
          center={center}
          onmapload={setMapInstance}
        />
      </div>
    </>
  );
};
 
export default ViewedSopInstanceMap;
 
 